import { SVGProps } from 'react'

export const WaveFormIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 32"
    width="64"
    height="32"
    fill="none"
    {...props}
  >
    <rect x="2" y="12" width="2" height="8" rx="1" fill="#9CA3AF" />
    <rect x="7" y="8" width="2" height="16" rx="1" fill="#9CA3AF" />
    <rect x="12" y="10" width="2" height="12" rx="1" fill="#9CA3AF" />
    <rect x="17" y="6" width="2" height="20" rx="1" fill="#9CA3AF" />
    <rect x="22" y="9" width="2" height="14" rx="1" fill="#9CA3AF" />
    <rect x="27" y="11" width="2" height="10" rx="1" fill="#9CA3AF" />
    <rect x="32" y="8" width="2" height="16" rx="1" fill="#9CA3AF" />
    <rect x="37" y="5" width="2" height="22" rx="1" fill="#9CA3AF" />
    <rect x="42" y="10" width="2" height="12" rx="1" fill="#9CA3AF" />
    <rect x="47" y="8" width="2" height="16" rx="1" fill="#9CA3AF" />
    <rect x="52" y="12" width="2" height="8" rx="1" fill="#9CA3AF" />
    <rect x="57" y="10" width="2" height="12" rx="1" fill="#9CA3AF" />
  </svg>
)
